<div class="sidebar">
	<app-sidebar-header [title]="'Original Flights'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar-wrapper" #sidebar__body>

		<section>
			<h2 class="title title-h4">These are your original flights</h2>

			<article class="old-flight--wrapper">
				<div class="top">
					<div>
						<strong>{{
								TAP_printFlightDate(oldflight)
							}}</strong>
					</div>
					<app-flight-details [flight]="oldflight"></app-flight-details>
				</div>
			</article>

			<article class="stopover--wrapper stopover--old" *ngIf="booked_trip.stopover===true">
				<app-svg class="stopover__logo" svg="icons.svg#services--hotel" [tooltip]="'Stopover in Lisbon'" [alt]="'Stopover in Lisbon'"></app-svg>
				<div class="stopover__text">
					<div class="stopover__time">2 days Stopover</div>
					<div class="stopover__label">Lisbon <span class="timeline__date">Apr 29 - May 02</span></div>
				</div>
			</article>

			<article class="old-flight--wrapper">
				<div class="top">
					<div>
						<strong>{{
								TAP_printFlightDate(booked_trip.flights[1])
							}}</strong>
					</div>
					<app-flight-details [flight]="booked_trip.flights[1]"></app-flight-details>
				</div>
			</article>
		</section>

		<section class="top-gap--extra">
			<h2 class="title title-h4">New Flights</h2>
			<p class="bottom-gap">All passengers were authomatcally moved to these flights. If you take no action, those are already booked. All
				you have to do is check-in and take the flights.</p>
			<article class="ticket vertical flight-card data-margin">
				<div class="top">
					<div>
						<strong>
							{{TAP_printFlightDate(booked_trip.flights[0])}}
						</strong>
					</div>
					<div class="ticket__header-tag tag--update" role="status" aria-label="This is a new flight">New flight</div>
					<app-flight-details [flight]="booked_trip.flights[0]"></app-flight-details>
				</div>
				<div class="tear-here">
					<div class="left"></div>
					<div class="divider-dashed"></div>
					<div class="right"></div>
				</div>

				<div class="bottom condensed">
					<div class="clearfix extras-flight__brand data-padding">
						<span class="fleft">
							<app-svg [ngClass]="[
										'brand--' + booked_trip.flights[0].options.brand
									]" svg="sprite.svg#brand--{{
										booked_trip.flights[0].options.brand
									}}" [attr.aria-label]="
										'Flight with ' +
										booked_trip.flights[0].options.brand +
										' fare'
									" [alt]="
										booked_trip.flights[0].options.brand + ' fare logo'
									"></app-svg>
						</span>
						<a class="link fright" href="javascript:;" (click)="
									TAP_handleTicketConditionsClick(booked_trip.flights[0])
								" aria-label="'Open fare Conditions details'">Fare Conditions</a>
					</div>
				</div>
			</article>

			<article class="stopover--wrapper" *ngIf="booked_trip.stopover===true">
				<app-svg class="stopover__logo" svg="icons.svg#services--hotel" [tooltip]="'Stopover in Lisbon'" [alt]="'Stopover in Lisbon'"></app-svg>
				<div class="stopover__text">
					<div class="stopover__time">2 days Stopover</div>
					<div class="stopover__label">Lisbon <span class="timeline__date">Apr 29 - May 02</span></div>
				</div>
			</article>

			<article class="ticket vertical flight-card data-margin">
				<div class="top">
					<div>
						<strong>{{
								TAP_printFlightDate(booked_trip.flights[1])
							}}</strong>
					</div>
					<app-flight-details [flight]="booked_trip.flights[1]"></app-flight-details>
				</div>
				<div class="tear-here">
					<div class="left"></div>
					<div class="divider-dashed"></div>
					<div class="right"></div>
				</div>

				<div class="bottom condensed">
					<div class="clearfix extras-flight__brand data-padding">
						<span class="fleft">
							<app-svg [ngClass]="[
										'brand--' + booked_trip.flights[1].options.brand
									]" svg="sprite.svg#brand--{{
										booked_trip.flights[1].options.brand
									}}" [attr.aria-label]="
										'Flight with ' +
										booked_trip.flights[1].options.brand +
										' fare'
									" [alt]="
										booked_trip.flights[1].options.brand + ' fare logo'
									"></app-svg>
						</span>
						<a class="link fright" href="javascript:;" (click)="TAP_handleTicketConditionsClick(booked_trip.flights[1])" aria-label="'Open fare Conditions details'">Fare Conditions</a>
					</div>
				</div>
			</article>
		</section>


		<section class="info-wrapper">
			<p>If you would rather take a different flight, you can change or cancel flights free of charge <a class="link link--external" href="javascript::">here</a>.</p>
		</section>

		<section class="link-wrapper"><a class="link link--external" href="javascript::">Review new flights</a></section>

		<div class="sidebar-flight-text border top-gap sidebar-flight-wrapper">
			<p>
				<a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()" href="javascript:;" role="button">Close this window</a>
			</p>
		</div>

	</div>
</div>
